export default {"src":"/_next/static/media/icon_move_link1.92f2b042.svg","height":17,"width":20,"blurWidth":0,"blurHeight":0};